const environment = {
    // apiUrl: 'https://localhost:44303/api/', // local
    apiUrl: 'https://roombooking-api.objective-faraday.119-59-118-127.plesk.page/api/', // VPS
    
}
export default environment